import { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import "./custom.css";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import "tw-elements";
import "react-toastify/dist/ReactToastify.css";
import toast, { Toaster } from "react-hot-toast";
import { CustomToastProvider } from "./components/customtoast/CustomToastProvider";
import ChatwootWidget from "./components/ChatwootWidget/ChatwootWidget";
import CandidateRoutes_ from "./pages/candidate/CandidateRoutes";
import ErrorBoundary from "../src/components/errorBoundary/errorBoundary";
import { UserContext } from "./context/index.js";
import LoginPage from "./pages/account/login";
import ForgotPassword from "./pages/account/forgotPassword";
import NotFoundPage from "./components/404Page/NotFoundPage.jsx";
import Redirect from "./pages/candidate/redirect/Redirect.jsx";
import JointExam from "./pages/joinExam/JointExam";
import JointExamLaunch from "./pages/joinExamLaunch/JointExam";
import ChatbotWidget from "./components/ChatbotWidget/ChatbotWidget";
import TranslationLoader from "./components/TranslationLoader";
import ViewResult from "./pages/candidate/view-result/ViewResult";
import Login from "./pages/account/login";

const queryClient = new QueryClient();

function App() {

  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const location = useLocation();
  const currentRoute = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const campaignId = queryParams.get("camapign_id");

  const [isOpen, setIsOpen] = useState(true);

  const toggleChat = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      const user = JSON.parse(userData);
      setUser((x) => ({ ...x, profile: user }));
    } else if (!userData && currentRoute.includes("/candidate")) {
      if (campaignId !== null)
        sessionStorage.setItem("profile-campaign-id", campaignId);
      navigate("/");
      toast.remove();
      toast("Login to your account");
    }
  }, []);

  const disabled = process.env.REACT_APP_DISABLE_ROUTE;

  return (
    <ErrorBoundary>
      <CustomToastProvider>
        <QueryClientProvider client={queryClient}>
          <UserContext.Provider value={{ user, setUser }}>
            <Routes>
              <Route path="/" element={<TranslationLoader>
                  <Login />
                </TranslationLoader>} /> 
              <Route
                path="/auth/forgot-password"
                element={<TranslationLoader><ForgotPassword /></TranslationLoader>}
              />
              <Route path="/candidate/*" element={<CandidateRoutes_ />} />
              <Route path="/joint-exam/:id" element={ <TranslationLoader><JointExam /></TranslationLoader> } />
              <Route path="/exams/:id/launch" element={ <TranslationLoader><JointExamLaunch /></TranslationLoader> } />
              <Route path="/redirect" element={<Redirect />} />
              <Route path="*" element={<NotFoundPage url={"/"} />} />
              <Route path="/" element={
                <TranslationLoader>
                  <LoginPage />
                </TranslationLoader>
              } />
              <Route path="/exam-result" element={
                <TranslationLoader>
                   <ViewResult />
                </TranslationLoader>
              } />
            </Routes>
          </UserContext.Provider>
        
         {
/*
*/
<ChatwootWidget />
}
{/* <SupportWidget/> */}

{/* <button onClick={e=>window.$chatwoot.toggle()}>
  CLick
</button> */}

          <ChatbotWidget
            src="https://bot.serviceschoolhouse.com/99472f4d-bf99-4804-8455-36a515979678/chatbot" />
          {/*<ReactQueryDevtools initialIsOpen={false} position="bottom-left" />*/}
        
        </QueryClientProvider>
        <Toaster
          toastOptions={{
            // style: {
            //   color: "#023047",
            // },
            success: {
              iconTheme: {
                primary: "#90EE90",
              },

              style: {
                color: "#023047",
              },
              duration: 6000,
            },
            error: {
              duration: 5000,
            },
          }}
        />
      </CustomToastProvider>
    </ErrorBoundary>
  );
}

export default App;
